module.exports = __webpack_public_path__ + "static/media/chatwork.32bc4a80.png";